import { render, staticRenderFns } from "./ScoreThresholdSettings.vue?vue&type=template&id=3f6de458&scoped=true"
import script from "./ScoreThresholdSettings.vue?vue&type=script&lang=js"
export * from "./ScoreThresholdSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6de458",
  null
  
)

export default component.exports